import { MonitorSearchType } from "../../shared/constants";
import type { Tab } from "../../shared/types/tab.type";
import type { MonitorSearchValues } from "./monitor.type";

export const alertsResultTableHeadings = [
  "monitoringResultsHeader.profileName",
  "profiles.assignedTo",
  "monitoringResultsHeader.amlAlerts",
  "monitoringResultsHeader.kycAlerts",
  "monitoringResultsHeader.dateOfLatestAlert",
  "monitoringResultsHeader.dateOfLatestMonitor",
  "",
];

export const MonitorSortByApiKeys = {
  mostRecentlyModified: "alertLastModifiedDate",
  dateOfLatestAlert: "latestAlertDate",
  undecidedSearchHitsCount: "undecidedSearchHitsCount",
  openKycAlertsCount: "openKycAlertsCount",
};

export const MonitorSortTypes = {
  openKycAlertsCount: "openKycAlertsCount",
  openAmlAlertsCount: "undecidedSearchHitsCount",
  mostRecentlyModified: "alertLastModifiedDate",
  dateOfLatestAlert: "dateOfLatestAlert",
};

export const MonitorSortingTypeLabels = [
  "undecidedSearchHitsCount",
  "openKycAlertsCount",
  "mostRecentlyModified",
  "dateOfLatestAlert",
];

export const MonitoringTabValues: Tab[] = [
  {
    id: "alerts-dashboard",
    name: "alertsDashboard",
    label: "monitor.tabs.alertsDashboard",
    noOfItems: 0,
  },
  {
    id: "monitoring-search",
    name: "monitorSearch",
    label: "monitor.tabs.monitorSearch",
    noOfItems: 0,
  },
];

export const monitorSearchBusinessResultTableHeadings = [
  "",
  "aml:amlScreenListDetails.businessName",
  "",
  "aml:amlBusinessProfileHits.categories",
  "common:threshold",
  "common:profile",
  "monitor:monitoringResultsHeader.assignedTo",
  "aml:amlScreenListDetails.riskRating",
];

export const monitorSearchIndividualResultTableHeadings = [
  "",
  "aml:amlIndividualProfileHits.name",
  "",
  "aml:amlScreenListDetails.dateOfBirth",
  "aml:amlScreenListDetails.gender",
  "aml:amlBusinessProfileHits.categories",
  "common:threshold",
  "aml:pepTiers.title",
  "common:profile",
  "monitor:monitoringResultsHeader.assignedTo",
  "aml:amlScreenListDetails.riskRating",
];

export const monitorSearchBusinessResultHitsTableHeadings = [
  "aml:amlIndividualProfileHits.name",
  "aml:amlIndividualProfileHits.countryLocation",
  "aml:amlIndividualProfileHits.categories",
  "aml:amlIndividualProfileHits.matchPercentage",
  "aml:amlIndividualProfileHits.matchDecision",
  "common:note",
];

export const monitorSearchIndividualResultHitsTableHeadings = [
  "aml:amlIndividualProfileHits.name",
  "",
  "aml:amlIndividualProfileHits.countryLocation",
  "aml:amlIndividualProfileHits.dob",
  "aml:amlIndividualProfileHits.gender",
  "aml:amlIndividualProfileHits.categories",
  "aml:pepTiers.title",
  "aml:amlIndividualProfileHits.matchPercentage",
  "aml:amlIndividualProfileHits.matchDecision",
  "common:note",
];

export const monitorSearchBothResultTableHeadings = [
  "",
  "common:type",
  "aml:amlIndividualProfileHits.name",
  "",
  "aml:amlScreenListDetails.dateOfBirth",
  "aml:amlScreenListDetails.gender",
  "aml:amlBusinessProfileHits.categories",
  "common:threshold",
  "aml:pepTiers.title",
  "common:profile",
  "monitor:monitoringResultsHeader.assignedTo",
  "aml:amlScreenListDetails.riskRating",
];

export const monitorSearchBothResultHitsTableHeadings = [
  "aml:amlIndividualProfileHits.name",
  "aml:amlIndividualProfileHits.countryLocation",
  "aml:amlScreenListDetails.dateOfBirth",
  "aml:amlScreenListDetails.gender",
  "aml:amlBusinessProfileHits.categories",
  "aml:pepTiers.title",
  "aml:amlIndividualProfileHits.matchPercentage",
  "aml:amlIndividualProfileHits.matchDecision",
  "common:note",
];

export const monitorSearchResultTableFilterOptions = [
  "aml:amlBusinessProfileHits.categories",
  "common:threshold",
  "aml:pepTiers.title",
];

export const defaultMonitorSearchValues: MonitorSearchValues = {
  name: "",
  firstName: "",
  middleName: "",
  lastName: "",
  searchType: MonitorSearchType.Both,
};

export const MIN_SEARCH_TERM_LENGTH = 3;
